import { z } from 'zod';
import { RoutineWeekdaySchema } from '../scheduled-routines.js';
// =============================================================================
// Admin: scheduled routines
// =============================================================================
export const AdminScheduledRoutineScheduleSchema = z.discriminatedUnion('kind', [
    z.object({
        kind: z.literal('times'),
        // Clock times in SAST. A group filters by weekday or by day of the month, never both;
        // both null means every day.
        groups: z.array(z.object({
            days: z.array(RoutineWeekdaySchema).nullable(),
            dayOfMonth: z.array(z.number()).nullable(),
            times: z.array(z.string()),
        })),
    }),
    z.object({ kind: z.literal('text'), text: z.string() }),
    z.object({ kind: z.literal('none') }),
]);
export const AdminScheduledRoutineSchema = z.object({
    id: z.string(),
    // Legacy entries (no `runner` in the manifest) are presented as 'wsl'.
    runner: z.enum(['wsl', 'systemd', 'external']),
    enabled: z.boolean(),
    procedure: z.string().nullable(),
    host: z.string().nullable(),
    provider: z.string().nullable(),
    registration: z.string().nullable(),
    schedule: AdminScheduledRoutineScheduleSchema,
    // Derived from the schedule, not reported by the host. `at` is an ISO instant.
    nextFire: z.object({ at: z.string(), isLowerBound: z.boolean() }).nullable(),
    // Present only while the pause is active.
    prsPause: z.object({ until: z.string(), note: z.array(z.string()) }).nullable(),
});
export const AdminScheduledRoutinesResponseSchema = z.object({
    revision: z.string(),
    routines: z.array(AdminScheduledRoutineSchema),
});
